module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_PowerOnOff_16"],"path":[{"$":{"d":"M9,8H7V0H9Zm2-5.32V4.18a5.69,5.69,0,1,1-6,0V2.68a7,7,0,1,0,6,0Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_PowerOnOff_16.svg
// module id = 8G8T
// module chunks = 1